var map = {
	"./logo-client.svg": "a390",
	"./logo-console.svg": "5358",
	"./logo-general.svg": "e736",
	"./logo-genesis-new.svg": "6c18",
	"./logo-genesis-with-text.svg": "8ddf",
	"./logo-genesis.svg": "8cec",
	"./logo-internal.svg": "5b0b",
	"./logo-lion-parcel-red.svg": "b9a5",
	"./logo-lion-parcel.svg": "880f",
	"./logo-lion.svg": "270b",
	"./logo-pos.svg": "d4f4",
	"./logo-sender.svg": "3364",
	"./logo-sub-console.svg": "324d",
	"./logo-vendor.svg": "96d7",
	"./logo.svg": "34cd",
	"./logout-image.svg": "39f0",
	"./logout-red.svg": "0a73",
	"./logout.svg": "d5fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "baed";